import CreateAttributeList, { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import WebDesigner from "../WebDesigner";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";

export default class BusinessProducts extends WBComponent {

    constructor() {
        super();
        this.vagaroLink = "https://www.vagaro.com/ShopOwner/ManageInventory.aspx";
        this.typename = wBComponentTypeNames.businessProducts;
        this.displayName = "Products";
        this.dropList = defaultDropList;
        this.editList = ["productFilters",componentAttributeTypes.multiLocation,componentAttributeTypes.alloWMultiLocalationBooking, componentAttributeTypes.layoutId, ...CreateAttributeList(true, true, true, true, false,false,false)];
        this.resizeType = ResizeableType.All;
        this.primaryEditAttributes = [componentAttributeTypes.multiLocation,"productFilters"];
        this.contentEditable = false;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512" fill="currentColor"><path d="M128 48V152.2c0 16-8 31-21.3 39.9C80.9 209.4 64 238.8 64 272V448c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V272c0-33.2-16.9-62.6-42.7-79.9C200 183.2 192 168.3 192 152.2V48l-64 0zM256 24c0 10.4-6.7 19.3-16 22.6V152.2c38.6 25.8 64 69.8 64 119.8V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V272c0-49.9 25.4-93.9 64-119.8V46.6C70.7 43.3 64 34.5 64 24C64 10.7 74.7 0 88 0L232 0c13.3 0 24 10.7 24 24zM160 384c-26.5 0-48-21.5-48-48c0-22.2 23-52 37.2-68.2c5.8-6.7 15.9-6.7 21.7 0C185 284 208 313.8 208 336c0 32-21.5 48-48 48z" /></svg>
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            new AttributeDefinition("productFilters","Filters","",AttributeInputType.ProductFilters)
        ]
    }


    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const atts = GetNodeDomAttributes("v-product-list   flex-wrap align-start overflow-auto resizable-container max-100 w-full vb-control", component, screenSize, isEditor);
        const layout = getNodeComponentAttributeValue(component, "productFilters", "");
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);

        if (!isEditor) {
            return <BusinessPlaceHolder node={component} dataKey="products" layout={layout} classNames={atts.className} />
        }

        return (
            <div {...atts} {...GetLocationHoverAtt(component,siteData)}>
                <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layout} dataKey="products" node={component} userContext={siteData} />
            </div>
        )
    }
}

